import React from "react";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { TabPanel } from "@mui/lab";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import { updateUserProfileCommunication } from "../service";
import "./CommunicationTab.css";
import { useNavigate } from "react-router-dom";
import { notifySuccess } from "../../../components/ToastNotification/ToastNotification";

const CommunicationTab = ({
  userProfile,
  setUserProfile,
  getUserProfile,
  setValue,
}) => {
  const { id, is_super_admin, user_access } = useSelector(
    (state) => state.userState
  );

  const navigate = useNavigate();

  const handleChangeCommunicationSetting = (e) => {
    setUserProfile({ ...userProfile, [e.target.name]: e.target.checked });
  };

  const handleCommunicationSettingsDataForm = async () => {
    const param = {
      first_name: userProfile.first_name,
      last_name: userProfile.last_name,
      communication_email: userProfile.communication_email,
      communication_phone_call: userProfile.communication_phone_call,
    };

    try {
      const resp = await updateUserProfileCommunication(id, param);
      if (resp) {
        notifySuccess("Updated Successfully.");
        getUserProfile();
        navigate("/")
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <TabPanel value="3">
        <Grid container spacing={8}>
          <Grid item size={{ xs:4, sm:12, md:7}}>
            <Typography
              variant="subtitle1"
              gutterBottom
              pt="20px"
              style={{ fontWeight: 600, color: "#001323" }}
            >
              {" "}
              Communications{" "}
            </Typography>
            <Typography variant="subtitle1">
              Would you like updates about <b>Hikar</b> promotions, products and
              services?
            </Typography>
            <Grid
              container
              spacing={2}
              pt={4}
              className="d-flex align-items-center"
            >
              <Grid item size={{xs: 4}}>
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: 600, color: "#001323" }}
                >
                  Email
                </Typography>
              </Grid>
              <Grid item size={{ xs: 2}}>
                  <Switch
                    checked={
                      userProfile ? userProfile.communication_email : false
                    }
                    name="communication_email"
                    onChange={handleChangeCommunicationSetting}
                    inputProps={{ "aria-label": "controlled" }}
                    defaultChecked
                    size="small"
                    color="success"
                  />
               
              </Grid>
            </Grid>
            <Grid container spacing={2} className="d-flex align-items-center">
              <Grid item size={{xs:4}}>
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: 600, color: "#001323" }}
                >
                  Phone Call
                </Typography>
              </Grid>
              <Grid item size={{xs:2}}>
                  <Switch
                    checked={
                      userProfile ? userProfile.communication_phone_call : false
                    }
                    name="communication_phone_call"
                    onChange={handleChangeCommunicationSetting}
                    inputProps={{ "aria-label": "controlled" }}
                    defaultChecked
                    size="small"
                    color="success"
                  />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box className="profileButton-wrap communicationTab">
          <button className="cancelButton" onClick={() => setValue("2")}>
            Cancel
          </button>
            <button
              className="updateButton"
              style={{ marginLeft: "10px" }}
              onClick={() => handleCommunicationSettingsDataForm()}
            >
              Update
            </button>
          
        </Box>
      </TabPanel>
    </>
  );
};
export default CommunicationTab;
